module.exports = __webpack_public_path__ + "img/liferecad_file.b9b4c9e4.svg";